/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
// import Orders from "../My Orders/Orders";
// import MyProfile from "./MyProfile";
// import Photos from "./Photos";
// import PaymentHistory from "./PaymentHistory";
// import ShippingDetails from "./ShippingDetails";
import { ImageURL } from "../../../Environment/Environment";

export default function ProfileDashboard({ AllDetails }) {
  const navigate = useNavigate();

  function Logout() {
    for (let key in localStorage) {
      if (key !== "userdata") {
        localStorage.removeItem(key);
      }
    }
    setuserDetails("");
    // localStorage.removeItem("token");
    navigate("/home");
  }

  // function navigateTOcompo(path) {
  //   console.log(path);
  //   navigate(path);
  // }
  const [userDetails, setuserDetails] = useState("");

  useEffect(() => {
    // console.log(AllDetails);
    setuserDetails(AllDetails);
  }, [AllDetails]);

  return (
    <div className="Gallery-Wraps-2 retouching dashboard">
      <main>
        <div className="tp-best-product-4__plr z-index-3">
          <div className="container custom-container-3">
            <div className="row">
              <div className="col-xl-3 col-lg-3">
                <div className="tp-best-product-4__left-box">
                  <div className="profile-section text-center">
                    <img
                      src={
                         localStorage.getItem("profile")
                          ? localStorage.getItem("profile")
                          : userDetails?.profile
                          ? ImageURL + userDetails?.profile
                          : "assets/img/breadcrumb/dummy-1.png"
                      }
                      alt=""
                      onError={(e) => {
                        e.target.src = "assets/img/breadcrumb/dummy-1.png";
                      }}
                    />
                    <h5 className="tp-best-product-4__title mt-3">
                      { localStorage.getItem("user")
                        ? localStorage.getItem("user")
                        : userDetails?.fullName
                        ? userDetails?.fullName
                        : ""}
                    </h5>
                    {/* <p className="color">User ID : 123465</p> */}
                  </div>
                  <hr />
                  <div className="tp-best-product-4__tab">
                    <nav>
                      <div className="nav nav-tab" id="nav-tab1" role="tablist">
                        <NavLink
                          className="nav-link "
                          // id="nav-Brochure-tab"
                          // data-bs-toggle="tab"
                          // data-bs-target="#nav-Brochure"
                          to={"/profile-dashboard/my-profile"}
                          // onClick={e=>{navigateTOcompo('/profile-dashboard/my-profile')}}
                          // type="button"
                          // role="tab"
                          // aria-controls="nav-Brochure"
                          // aria-selected="false"
                          // tabIndex={-1}
                        >
                          <span>
                            My Profile
                            <i className="far  ">
                              <svg
                                width={22}
                                height={22}
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11 0C4.928 0 0 4.928 0 11C0 17.072 4.928 22 11 22C17.072 22 22 17.072 22 11C22 4.928 17.072 0 11 0ZM11 3.3C12.826 3.3 14.3 4.774 14.3 6.6C14.3 8.426 12.826 9.9 11 9.9C9.174 9.9 7.7 8.426 7.7 6.6C7.7 4.774 9.174 3.3 11 3.3ZM11 18.92C8.25 18.92 5.819 17.512 4.4 15.378C4.433 13.189 8.8 11.99 11 11.99C13.189 11.99 17.567 13.189 17.6 15.378C16.181 17.512 13.75 18.92 11 18.92Z"
                                  fill="#30373D"
                                />
                              </svg>
                            </i>
                          </span>
                        </NavLink>
                        <NavLink
                          className="nav-link "
                          id="nav-Labeling-tab"
                          // data-bs-toggle="tab"
                          // data-bs-target="#nav-Labeling"
                          // onClick={e=>{navigateTOcompo('/profile-dashboard/my-orders')}}
                          to={"/profile-dashboard/my-orders"}
                          type="button"
                          role="tab"
                          aria-controls="nav-Labeling"
                          aria-selected="false"
                          tabIndex={-1}
                        >
                          <span>
                            My Order History
                            <i className="far">
                              <svg
                                width={22}
                                height={22}
                                viewBox="0 0 22 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.9916 21.9998C7.72774 21.9998 4.46379 21.9999 1.19984 21.9998C0.379874 21.9997 0.00128209 21.6187 0.00123523 20.7932C0.00109466 15.5074 -0.00551188 10.2215 0.013324 4.93583C0.0148702 4.50246 0.181394 4.06759 0.286491 3.63713C0.510132 2.72086 0.744643 1.80727 0.973063 0.892229C1.12651 0.277358 1.47399 0.00346804 2.1109 0.00342119C7.68613 0.00314008 13.2614 0.00538893 18.8366 1.07737e-06C19.3819 -0.000561133 19.7423 0.218888 19.9828 0.715461C20.5876 1.96436 21.2247 3.19757 21.8324 4.44512C21.9313 4.64812 21.9926 4.89203 21.993 5.11715C22.0018 10.3717 22.0003 15.6263 21.9991 20.8809C21.999 21.5926 21.5906 21.999 20.8771 21.9992C17.5819 22.0005 14.2868 21.9998 10.9916 21.9998ZM2.28722 3.99455C7.98647 3.99455 13.6572 3.99455 19.3579 3.99455C19.3177 3.9039 19.2898 3.83409 19.2565 3.76709C19.003 3.25745 18.7389 2.75282 18.4994 2.23671C18.4137 2.05207 18.3089 2.00114 18.1107 2.00142C13.0988 2.00751 8.08688 2.0062 3.075 2.0062C3.02032 2.0062 2.95894 1.99055 2.91274 2.01032C2.85318 2.03586 2.77212 2.08088 2.75839 2.13284C2.5974 2.74213 2.44737 3.35429 2.28722 3.99455Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.0049 15.1308C10.0049 14.9893 10.0049 14.9058 10.0049 14.8223C10.005 12.9022 10.0033 10.9821 10.0062 9.06201C10.0071 8.47759 10.3831 8.04886 10.9173 8.00594C11.513 7.95811 11.9911 8.40652 11.9941 9.03596C12.0003 10.2848 11.9962 11.5337 11.9963 12.7825C11.9963 13.485 11.9959 14.1875 11.9969 14.89C11.997 14.9645 12.0044 15.039 12.0109 15.1596C12.2655 14.9848 12.4878 14.8327 12.7096 14.68C12.9731 14.4986 13.2343 14.3139 13.4998 14.1355C13.9804 13.8123 14.5901 13.9243 14.903 14.3899C15.2181 14.8589 15.0969 15.4642 14.6152 15.7867C13.617 16.4551 12.616 17.1191 11.6162 17.7851C11.1995 18.0626 10.788 18.0584 10.3734 17.775C9.43298 17.1326 8.48927 16.4952 7.54813 15.8539C7.05512 15.518 6.93231 14.908 7.25978 14.4404C7.58252 13.9796 8.1833 13.8793 8.66498 14.2084C9.09562 14.5027 9.52435 14.7998 10.0049 15.1308Z"
                                  fill="white"
                                />
                              </svg>
                            </i>
                          </span>
                        </NavLink>
                        {/* <NavLink
                          className="nav-link "
                          id="nav-design-tab"
                          // data-bs-toggle="tab"
                          // data-bs-target="#nav-design"
                          to={"/profile-dashboard/photos"}
                          type="button"
                          role="tab"
                          aria-controls="nav-design"
                          aria-selected="false"
                          tabIndex={-1}
                        >
                          <span>
                            Photos
                            <i className="far  ">
                              <svg
                                width={26}
                                height={24}
                                viewBox="0 0 26 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 16.1623C0.332096 15.0583 0.665319 13.9547 0.996091 12.8504C1.51202 11.1284 2.02622 9.40592 2.54161 7.68379C2.55757 7.63055 2.57943 7.57909 2.65267 7.5293C2.65267 7.62042 2.65267 7.7116 2.65267 7.80272C2.65267 10.0116 2.64743 12.2204 2.65459 14.4293C2.65942 15.9167 3.26123 17.0998 4.51313 17.9241C5.19507 18.3731 5.96019 18.5477 6.77192 18.5475C11.7439 18.546 16.7159 18.5468 21.6879 18.5468C21.7847 18.5468 21.8814 18.5468 22.0037 18.5468C21.7238 19.4385 21.4528 20.3029 21.1813 21.167C21.1295 21.3323 21.0781 21.4977 21.0234 21.6621C20.7356 22.5283 20.1342 23.0484 19.2555 23.2625C19.2086 23.2738 19.1643 23.296 19.1189 23.3132C18.8706 23.3132 18.6223 23.3132 18.374 23.3132C18.2817 23.2832 18.1905 23.2487 18.0969 23.2237C12.6869 21.7761 7.27639 20.3301 1.86656 18.8819C1.01721 18.6545 0.428381 18.1333 0.126018 17.3012C0.078935 17.1717 0.0417852 17.0386 6.61842e-05 16.9071C-3.63792e-08 16.6589 0 16.4105 0 16.1623Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M14.8331 0.00212964C17.4314 0.00212964 20.0297 0.00616925 22.628 1.07366e-05C23.5973 -0.00224076 24.3845 0.349523 24.9513 1.14477C25.2661 1.58646 25.424 2.08576 25.4239 2.63182C25.4237 6.52923 25.4266 10.4267 25.4225 14.3241C25.4209 15.7827 24.2461 16.9535 22.7844 16.9543C17.5133 16.9577 12.2423 16.9563 6.97123 16.9554C5.38604 16.9551 4.23082 15.8065 4.2287 14.22C4.22473 11.2163 4.22751 8.21256 4.22751 5.20879C4.22751 4.40613 4.22671 3.60347 4.22771 2.80081C4.22976 1.14583 5.3573 0.00709589 7.01341 0.0035862C9.61999 -0.00197633 12.2266 0.00212964 14.8331 0.00212964ZM23.2438 10.0946C23.2614 10.0875 23.279 10.0803 23.2966 10.0732C23.2966 9.99224 23.2966 9.91132 23.2966 9.83033C23.2966 7.49685 23.2968 5.16343 23.2965 2.82995C23.2965 2.29469 23.1357 2.1298 22.6056 2.12973C17.4257 2.12907 12.2458 2.12914 7.06586 2.12967C6.52622 2.12973 6.35498 2.3033 6.35498 2.84399C6.35478 6.01317 6.35491 9.18236 6.35491 12.3515C6.35491 12.4301 6.35491 12.5086 6.35491 12.6361C6.45272 12.5456 6.51311 12.4935 6.56933 12.4372C7.45921 11.5484 8.34921 10.6596 9.23769 9.76947C9.69508 9.31116 10.2409 9.11813 10.8841 9.2111C11.3002 9.27123 11.6487 9.46413 11.9423 9.7602C12.3525 10.174 12.7615 10.5891 13.1758 11.0085C13.2368 10.9415 13.2715 10.9063 13.303 10.8685C14.558 9.36228 15.814 7.85689 17.0671 6.34924C17.8654 5.38878 19.1811 5.36779 20.0007 6.31137C20.5214 6.91093 21.0342 7.51744 21.551 8.12051C22.1151 8.77868 22.6796 9.43658 23.2438 10.0946Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M23.2444 10.0943C22.6801 9.43624 22.1157 8.7784 21.5516 8.12017C21.0348 7.5171 20.522 6.91058 20.0012 6.31102C19.1816 5.36744 17.866 5.38843 17.0677 6.3489C15.8146 7.85661 14.5586 9.36194 13.3036 10.8681C13.272 10.9059 13.2373 10.9412 13.1764 11.0082C12.7621 10.5887 12.3531 10.1737 11.9429 9.75986C11.6492 9.46372 11.3008 9.27088 10.8846 9.21075C10.2415 9.11778 9.69565 9.31081 9.23827 9.76913C8.34979 10.6593 7.45978 11.548 6.56991 12.4369C6.51362 12.4931 6.45329 12.5453 6.35549 12.6358C6.35549 12.5082 6.35549 12.4297 6.35549 12.3511C6.35549 9.18202 6.35542 6.01283 6.35555 2.84364C6.35555 2.30295 6.5268 2.12939 7.06643 2.12932C12.2463 2.12879 17.4262 2.12872 22.6062 2.12939C23.1363 2.12945 23.297 2.29434 23.2971 2.8296C23.2974 5.16309 23.2972 7.4965 23.2972 9.82998C23.2972 9.91097 23.2972 9.99189 23.2972 10.0729C23.2796 10.08 23.262 10.0872 23.2444 10.0943ZM9.53672 7.42075C10.7002 7.42015 11.6549 6.47339 11.6617 5.31327C11.6687 4.14474 10.7064 3.18229 9.53275 3.18388C8.36892 3.18541 7.41349 4.13335 7.4074 5.29248C7.40131 6.46008 8.3629 7.42128 9.53672 7.42075Z"
                                  fill="white"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.53756 7.42052C8.36373 7.42105 7.40214 6.45993 7.40823 5.29219C7.41432 4.13313 8.36976 3.18518 9.53358 3.1836C10.7073 3.18207 11.6696 4.14446 11.6626 5.31299C11.6557 6.47317 10.7009 7.41993 9.53756 7.42052Z"
                                  fill="#30373D"
                                />
                              </svg>
                            </i>
                          </span>
                        </NavLink> */}
                        <NavLink
                          className="nav-link"
                          id="nav-Paper-tab"
                          // data-bs-toggle="tab"
                          // data-bs-target="#nav-Paper"
                          type="button"
                          role="tab"
                          aria-controls="nav-Paper"
                          aria-selected="false"
                          tabIndex={-1}
                          to={"/profile-dashboard/payment-history"}
                        >
                          <span>
                            Payment History
                            <i className="far  ">
                              <svg
                                width={27}
                                height={24}
                                viewBox="0 0 27 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M19.8865 11.768C19.8864 15.2805 17.0388 18.1316 13.5339 18.1287C10.0108 18.1257 7.17199 15.2785 7.17579 11.7517C7.17958 8.25938 10.0332 5.41029 13.5286 5.40918C17.0341 5.40813 19.8866 8.26108 19.8865 11.768ZM14.2566 16.1106C14.2566 15.8297 14.2481 15.5738 14.2622 15.3192C14.2661 15.2498 14.3214 15.1555 14.3811 15.1212C15.1119 14.7008 15.5069 14.0746 15.4903 13.2318C15.4739 12.3971 15.0543 11.7922 14.3197 11.4031C13.9508 11.2077 13.578 11.0192 13.2148 10.814C12.9486 10.6637 12.8441 10.3833 12.921 10.0979C12.9942 9.82666 13.2355 9.63837 13.5189 9.63144C13.8071 9.62437 14.0529 9.80795 14.14 10.0953C14.1563 10.1494 14.1724 10.2036 14.187 10.2526C14.662 10.2526 15.1204 10.2526 15.5772 10.2526C15.6386 9.52738 15.1507 8.74315 14.4172 8.39986C14.2865 8.33864 14.2487 8.2718 14.2543 8.13825C14.2641 7.90654 14.2571 7.67403 14.2571 7.43551C13.7623 7.43551 13.2964 7.43551 12.8071 7.43551C12.8071 7.68659 12.8173 7.9274 12.8011 8.16644C12.7962 8.23976 12.7362 8.34185 12.6728 8.3737C11.9089 8.75728 11.4788 9.37539 11.4614 10.2229C11.444 11.0695 11.8413 11.7111 12.5964 12.1156C12.9774 12.3198 13.3634 12.5146 13.7409 12.7248C14.004 12.8714 14.114 13.1733 14.0324 13.4661C13.9575 13.735 13.6948 13.9173 13.3963 13.9073C13.1012 13.8974 12.8798 13.7095 12.8075 13.4088C12.7978 13.3685 12.783 13.3294 12.7738 13.2997C12.2925 13.2997 11.8268 13.2997 11.3624 13.2997C11.3334 14.0901 11.8702 14.8825 12.6493 15.1938C12.7765 15.2446 12.8148 15.3052 12.8099 15.4327C12.8013 15.6571 12.8075 15.8821 12.8075 16.1104C13.3016 16.1106 13.7626 16.1106 14.2566 16.1106Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M27.0009 18.7856C26.5138 19.2592 26.0307 19.7189 25.5588 20.1896C24.4993 21.2466 23.4449 22.3087 22.3899 23.3703C22.2778 23.4831 22.1691 23.6006 21.9922 23.5267C21.8203 23.4546 21.8086 23.2988 21.8092 23.1375C21.8111 22.5213 21.8099 21.905 21.8099 21.2617C19.857 21.2617 17.9165 21.2617 15.9568 21.2617C15.9489 21.174 15.9384 21.1114 15.9383 21.0488C15.9374 20.1826 15.9425 19.3163 15.9336 18.4502C15.9321 18.2968 15.9872 18.2332 16.1206 18.1798C17.1182 17.7803 17.9701 17.1722 18.6944 16.3786C18.7612 16.3054 18.8927 16.2568 18.9949 16.2558C19.9193 16.2465 20.8439 16.2504 21.7969 16.2504C21.8018 16.1647 21.8098 16.0878 21.8099 16.0109C21.8111 15.4603 21.8102 14.9098 21.811 14.3591C21.8112 14.2015 21.8169 14.0465 22.0002 13.977C22.1733 13.9115 22.276 14.0193 22.3808 14.1247C23.8612 15.6128 25.3416 17.1009 26.8215 18.5895C26.8719 18.6401 26.9182 18.6949 27.0009 18.7856Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M0 4.80392C0.853817 3.96841 1.64923 3.1974 2.43614 2.41781C3.18695 1.674 3.92952 0.921881 4.67398 0.171726C4.78693 0.0579924 4.89798 -0.0472388 5.07542 0.022283C5.24991 0.0906929 5.24343 0.243864 5.24357 0.39239C5.24396 0.950331 5.25135 1.50834 5.2401 2.06601C5.23637 2.25182 5.29576 2.29884 5.47653 2.29819C7.26035 2.29172 9.04418 2.29407 10.8281 2.29394C10.9214 2.29394 11.0147 2.29394 11.1149 2.29394C11.1202 2.38236 11.1267 2.43978 11.1268 2.49727C11.1274 3.36351 11.1245 4.22976 11.13 5.096C11.1308 5.23132 11.0958 5.30444 10.9619 5.35735C9.96954 5.74897 9.11612 6.34478 8.40494 7.14006C8.30854 7.24784 8.21005 7.29133 8.06499 7.29022C7.21346 7.28368 6.36187 7.28702 5.51034 7.28702C5.43107 7.28702 5.35174 7.28702 5.24376 7.28702C5.24376 7.54764 5.24383 7.7878 5.24376 8.02808C5.24363 8.43913 5.25449 8.85077 5.23532 9.26096C5.23042 9.36528 5.15155 9.51747 5.06724 9.55233C4.98222 9.58751 4.81394 9.53918 4.74069 9.46763C3.17171 7.93403 1.61104 6.39219 0 4.80392Z"
                                  fill="#30373D"
                                />
                              </svg>
                            </i>
                          </span>
                        </NavLink>
                        <NavLink
                          className="nav-link"
                          id="nav-heels-tab"
                          // data-bs-toggle="tab"
                          // data-bs-target="#nav-heels"
                          to={"/profile-dashboard/shipping-details"}
                          type="button"
                          role="tab"
                          aria-controls="nav-heels"
                          aria-selected="false"
                          tabIndex={-1}
                        >
                          <span>
                            Shipping Details
                            <i className="far  ">
                              <svg
                                width={29}
                                height={23}
                                viewBox="0 0 29 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M14.6981 15.9933C14.5685 15.9933 14.4609 15.9933 14.3532 15.9933C12.1209 15.9933 9.88848 15.9935 7.6562 15.9931C7.08712 15.993 6.93571 15.8384 6.93554 15.2587C6.93527 14.0371 6.94238 12.8153 6.92976 11.5938C6.92718 11.3447 6.99116 11.1972 7.21542 11.0641C7.94026 10.6339 8.66332 10.1974 9.35813 9.721C10.3262 9.05729 10.7495 8.11894 10.5328 6.95642C10.3274 5.8545 9.65356 5.11144 8.56257 4.85218C8.0531 4.73107 7.49938 4.79602 6.93545 4.7755C6.93545 4.00276 6.93545 3.13807 6.93545 2.27329C6.93545 1.70687 6.93136 1.14045 6.93714 0.574113C6.94087 0.210182 7.13136 0.00395876 7.48321 0.00298141C9.23739 -0.00199422 10.9916 0.00076069 12.7898 0.00076069C12.7898 1.57937 12.7898 3.1458 12.7898 4.79478C13.5449 4.23084 14.2327 3.71729 14.9331 3.19422C15.6309 3.71516 16.3189 4.22862 17.061 4.7826C17.061 3.15406 17.061 1.5958 17.061 0.0171978C17.1886 0.010534 17.2851 0.00111527 17.3816 0.00102642C19.003 0.000137912 20.6246 -0.000128444 22.2461 0.00067121C22.7563 0.000937762 22.9276 0.169488 22.9278 0.673625C22.9288 2.67276 22.9283 4.6719 22.9283 6.67103C22.9283 6.75899 22.9283 6.84696 22.9283 6.95429C20.1183 5.89288 17.5773 6.29217 15.5536 8.5201C13.539 10.7379 13.3976 13.2979 14.6981 15.9933Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.2043 17.0622C10.1215 19.0476 9.07154 20.9726 8.00285 22.932C5.33432 21.3613 2.68222 19.8004 0 18.2216C0.0593521 18.1085 0.11204 18.0038 0.168194 17.9012C0.880863 16.5975 1.58953 15.2918 2.30949 13.9922C2.55801 13.5434 2.67662 13.0737 2.67227 12.5613C2.66312 11.4951 2.6632 10.4287 2.67156 9.36242C2.67849 8.4796 3.09191 7.82415 3.87948 7.44743C4.96879 6.92632 6.07391 6.43729 7.18045 5.95332C8.0096 5.59063 8.91375 5.90401 9.32992 6.66874C9.74894 7.43872 9.52131 8.3593 8.75613 8.85828C7.91071 9.40933 7.05224 9.9411 6.18799 10.4622C5.9536 10.6036 5.85569 10.7504 5.85827 11.0356C5.87391 12.7793 5.86591 14.5231 5.86618 16.2669C5.86626 16.8969 6.02842 17.0619 6.64735 17.0621C8.02462 17.0626 9.40189 17.0623 10.7792 17.0623C10.9001 17.0622 11.0211 17.0622 11.2043 17.0622Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M24.4108 16.1695C25.7441 17.5056 27.0614 18.8253 28.3778 20.1457C28.4639 20.232 28.5587 20.3142 28.6249 20.4145C28.7787 20.6479 28.7583 20.8849 28.5642 21.0831C28.3595 21.2922 28.1157 21.3153 27.8706 21.1491C27.78 21.0877 27.7057 21.0014 27.6272 20.9229C26.3872 19.6826 25.1471 18.4421 23.909 17.1995C23.8234 17.1134 23.7554 17.0096 23.6844 16.9203C20.9897 18.9875 17.6804 18.1845 16.038 16.063C14.3759 13.916 14.6024 10.8135 16.5886 8.92278C18.5868 7.02058 21.6852 6.96078 23.7939 8.79634C25.7873 10.5318 26.3233 13.7074 24.4108 16.1695ZM20.2583 17.062C22.595 17.0628 24.5194 15.1456 24.5264 12.8102C24.5332 10.4646 22.5964 8.52802 20.249 8.53317C17.906 8.53841 15.9918 10.4763 15.9972 12.8378C16.0024 15.142 17.9384 17.0613 20.2583 17.062Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M20.2581 17.0621C17.9383 17.0613 16.0023 15.1421 15.9971 12.8378C15.9917 10.4764 17.9059 8.53837 20.2489 8.53321C22.5964 8.52797 24.5331 10.4646 24.5263 12.8102C24.5193 15.1456 22.5949 17.0628 20.2581 17.0621ZM22.9126 13.3533C21.1278 13.3533 19.3722 13.3533 17.6144 13.3533C17.6144 13.7049 17.6144 14.0331 17.6144 14.3763C19.3862 14.3763 21.1418 14.3763 22.9126 14.3763C22.9126 14.0309 22.9126 13.7028 22.9126 13.3533ZM19.7566 11.2102C19.7566 11.5764 19.7566 11.9123 19.7566 12.2338C20.8274 12.2338 21.8725 12.2338 22.908 12.2338C22.908 11.8783 22.908 11.5503 22.908 11.2102C21.8512 11.2102 20.8141 11.2102 19.7566 11.2102Z"
                                  fill="white"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M22.4019 13.3535C22.6844 13.3535 22.9134 13.5841 22.9134 13.8666C22.9134 14.1491 22.6844 14.3765 22.4019 14.3765C20.9744 14.3765 19.5549 14.3765 18.1267 14.3765C17.8442 14.3765 17.6152 14.1507 17.6152 13.8682C17.6152 13.5857 17.8442 13.3535 18.1267 13.3535C19.5457 13.3535 20.9653 13.3535 22.4019 13.3535Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M19.7568 11.7386C19.7568 11.4559 19.986 11.21 20.2687 11.21C20.9801 11.21 21.6852 11.21 22.3964 11.21C22.679 11.21 22.9082 11.4333 22.9082 11.716C22.9082 11.9986 22.679 12.2336 22.3964 12.2336C21.6944 12.2336 20.9868 12.2336 20.2687 12.2336C19.986 12.2336 19.7568 12.0212 19.7568 11.7386Z"
                                  fill="#30373D"
                                />
                              </svg>
                            </i>
                          </span>
                        </NavLink>
                        <NavLink
                          className="nav-link"
                          id="change-Paper-tab"
                          type="button"
                          role="tab"
                          aria-controls="change-Paper"
                          aria-selected="false"
                          tabIndex={-1}
                          to={"/profile-dashboard/change-password"}
                        >
                          <span>
                            Change Password
                            <i className="far  ">
                              <i class="text-dark fs-5 fa-solid fa-key"></i>
                            </i>
                          </span>
                        </NavLink>
                        <button
                          className="nav-link "
                          id="nav-Shirt-tab"
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdroplogout"
                          type="button"
                          role="tab"
                          aria-controls="nav-Shirt"
                          aria-selected="true"
                        >
                          <span>
                            Logout
                            <i className="far">
                              <svg
                                width={26}
                                height={22}
                                viewBox="0 0 26 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.1176 14.8898C9.94765 14.8898 8.77758 14.9022 7.60791 14.8839C7.11259 14.8762 6.68377 14.6892 6.49293 14.1817C6.42563 14.0028 6.38583 13.8023 6.38496 13.6115C6.37568 11.6289 6.36727 9.6461 6.38209 7.66353C6.38583 7.16026 6.55657 6.70047 7.08828 6.50509C7.28199 6.43384 7.49921 6.39598 7.70587 6.39518C9.98491 6.3869 12.264 6.3891 14.543 6.38797C14.8796 6.38777 14.8798 6.38663 14.8801 6.05984C14.8815 4.66208 14.875 3.26412 14.8895 1.86649C14.8934 1.49797 14.9562 1.13332 15.2572 0.855476C15.6184 0.521877 16.2745 0.50712 16.6237 0.854674C17.8834 2.10861 19.1391 3.36675 20.396 4.62355C21.7012 5.9287 23.0061 7.23418 24.3111 8.53953C24.7515 8.98003 25.1876 9.42488 25.6337 9.85957C25.886 10.1054 26.0278 10.3785 25.9954 10.7443C25.973 10.9975 25.8544 11.1892 25.6884 11.3558C24.4075 12.6421 23.1226 13.9244 21.8388 15.2078C20.1199 16.9262 18.401 18.645 16.6814 20.3629C16.3887 20.6553 16.0406 20.7966 15.639 20.6461C15.2476 20.4994 14.9701 20.2255 14.9449 19.7802C14.9133 19.2222 14.8882 18.6631 14.8833 18.1043C14.8744 17.1244 14.8764 16.1443 14.8891 15.1645C14.8921 14.9405 14.8195 14.8843 14.6045 14.886C13.4424 14.8954 12.28 14.8905 11.1177 14.8905C11.1176 14.8903 11.1176 14.8901 11.1176 14.8898Z"
                                  fill="#30373D"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M2.13053 10.6536C2.13053 12.7274 2.12131 14.8012 2.13814 16.8748C2.14155 17.3 2.32911 17.6875 2.58458 18.0371C3.12071 18.7707 3.8249 19.149 4.7451 19.1427C6.39346 19.1312 8.04196 19.137 9.69039 19.1435C9.88376 19.1443 10.0783 19.1874 10.2696 19.2249C10.5869 19.287 10.6093 19.5665 10.6219 19.7983C10.6393 20.1189 10.6137 20.4465 10.5662 20.7651C10.51 21.1414 10.3237 21.2758 9.94038 21.2757C8.63383 21.2751 7.32728 21.2728 6.0208 21.2719C5.71698 21.2716 5.41236 21.2883 5.10941 21.2729C4.21011 21.2271 3.32189 21.1294 2.51621 20.671C1.90771 20.3249 1.42594 19.8425 0.981962 19.3099C0.561024 18.8049 0.320307 18.2197 0.15758 17.5949C0.116181 17.436 0.0791888 17.2716 0.0730456 17.1086C0.0433316 16.3151 0.00694018 15.5213 0.00540439 14.7275C-0.00093906 11.484 -0.00454469 8.24044 0.0112138 4.99693C0.0160882 3.98886 0.210265 3.01136 0.818501 2.17316C1.49051 1.24722 2.33285 0.527202 3.46272 0.225387C3.82102 0.129634 4.2027 0.0939779 4.57516 0.0836281C5.95289 0.045367 7.33116 0.0275385 8.70929 0.00583724C9.10418 -0.000372663 9.49988 -0.00591476 9.89404 0.0131156C10.0613 0.0212619 10.2378 0.0687373 10.3882 0.142722C10.6081 0.250761 10.6147 0.498156 10.6237 0.696205C10.638 1.00977 10.5951 1.32634 10.5709 1.64118C10.5449 1.97691 10.3525 2.1329 9.96015 2.13697C8.68418 2.15032 7.40788 2.14124 6.13178 2.14084C5.54691 2.14071 4.96124 2.12188 4.37738 2.14645C3.95531 2.16428 3.58445 2.35118 3.23602 2.5939C2.64041 3.00883 2.30213 3.58488 2.13527 4.27378C2.10742 4.38883 2.12819 4.51583 2.12812 4.63729C2.12792 6.64269 2.12799 8.64809 2.12799 10.6536C2.12879 10.6536 2.12966 10.6536 2.13053 10.6536Z"
                                  fill="#30373D"
                                />
                              </svg>
                            </i>
                          </span>
                        </button>
                        {/* Button trigger modal */}
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
              <div className="col-xl-9 col-lg-9">
                <div className="tab-content" id="nav-tabContent2">
                  <Outlet />

                  {/* <MyProfile />

                  <Orders />

                  <Photos />

                  <PaymentHistory />

                  <ShippingDetails /> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <UpperFooterSlider />
      </main>

      {/* Modal */}
      <div
        className="modal fade"
        id="staticBackdroplogout"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            {/* <div class="modal-header">
  <h5 class="modal-title" id="staticBackdropLabel">Modal title</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div> */}
            <div className="modal-body">
              <div className="modal-body popup border-0 pt-30">
                <h4>Are you sure want to logout?</h4>
                {/* <p>lorem ipsum dolor elit dummy ispum</p> */}
              </div>
            </div>
            <div className="modal-footer m-auto pb-30">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={Logout}
              >
                OKAY
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
